import EBP from './EBP';

export default EBP;



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/Inventory/EBP/index.tsx